import incident from '@/components/Neris/Services/structureManagers/incident';
import entity from '@/components/Neris/Services/structureManagers/entity';

const index = {
  incident,
  entity,
};

export default index;
